export default "__VITE_ASSET__CzI1302I__ 640w, __VITE_ASSET__BXHOLkuV__ 1024w, __VITE_ASSET__D8zq9UUe__ 1536w";